const initFilterPopover = () => {
  const filterPopover = document.getElementById("filter-popover");
  const filterPopoverTrigger = document.getElementById("filter-popover-trigger");

  if (!filterPopover || !filterPopoverTrigger) {
    return;
  }

  let filterPopoverActive = filterPopoverTrigger.offsetParent !== null;
  if (filterPopoverActive) {
    filterPopover.setAttribute("popover", "");
  }

  window.addEventListener("resize", () => {
    filterPopoverActive = filterPopoverTrigger.offsetParent !== null;
    if (filterPopoverActive) {
      filterPopover.setAttribute("popover", "");
    } else {
      filterPopover.removeAttribute("popover");
    }
  });
};

export { initFilterPopover };
